import { useChatboxStateContext } from "../../context/ChatboxContext"
import { useConversationStateContext } from "../../context/ConversationContext";
import ChatboxVariable from "./ChatboxVariable/ChatboxVariable";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import VariableAction from "../../actions/VariableAction";
import { useState, useEffect, useRef } from "react";

function ChatboxVariablesContainer() {
    const { valueToggleVariablesList } = useChatboxStateContext();
    const { data } = useConversationStateContext();
    const { variables } = data;
    const [display, setDisplay] = useState(valueToggleVariablesList == false ? 'none' : 'flex');
    const { deleteAllVariable } = VariableAction();

    const onDelete = () => deleteAllVariable();
    const isInitialMount = useRef(true);

    useEffect(() => {
        if(isInitialMount.current) {
            isInitialMount.current = false;
            return
        }

        valueToggleVariablesList == true ? setDisplay('flex') : setTimeout(() => setDisplay('none'), 350)
    }, [valueToggleVariablesList])

    return (
        <div className={ valueToggleVariablesList ? "kwalys-chatbox-variable visible" : "kwalys-chatbox-variable"} style={{ display }}>
                <h3>
                <IconButton style={{ position : 'absolute', left : 140, top : 16}} className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={onDelete}></IconButton>
                    List of Variables
                    </h3>
            <div className="kwalys-list-variable scrollbar-chatbox">
                {display == 'flex' && variables && variables.map((variable, index) => <ChatboxVariable {...variable} key={index} /> )}
            </div>
        </div>
    )
}

export default ChatboxVariablesContainer;